import { render, staticRenderFns } from "./DayOff.vue?vue&type=template&id=06f5e2a4&scoped=true"
import script from "./DayOff.vue?vue&type=script&lang=js"
export * from "./DayOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f5e2a4",
  null
  
)

export default component.exports